module.exports = __webpack_public_path__ + "img/mcb-r1.b3ecc455.gif";